module.exports = __webpack_public_path__ + "img/oreal.1df33dab.jpg";